/**
 * Catalog items should have unique `id` (legacyId). Duplicate rows (e.g. two Sanity
 * documents with the same legacyId) break React lists keyed by `item.id`.
 * Keeps the first occurrence per id.
 * @param {Array<{ id?: unknown }>|undefined|null} items
 * @returns {Array}
 */
export function dedupeCatalogItemsById(items) {
  if (!Array.isArray(items)) return items
  const seen = new Set()
  const out = []
  for (const item of items) {
    if (item == null) continue
    const raw = item.id
    if (raw === undefined || raw === null) {
      out.push(item)
      continue
    }
    const key = String(raw)
    if (seen.has(key)) continue
    seen.add(key)
    out.push(item)
  }
  return out
}
